import React, { useEffect, useState } from "react";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";
import config from "../../config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { encodedDashboard } from "../../App";
import { pdf } from "@react-pdf/renderer";
import ScrutinyPDF from "../ScrutinyPDF";

function StudentInformation() {
  const Navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [studentData, setStudentData] = useState(null);
  const [fees, setFees] = useState("");
  const [scrutinySubjects, setScrutinySubjects] = useState({
    SUB_1: false,
    SUB_2: false,
    SUB_3: false,
    SUB_4: false,
    SUB_5: false,
    SUB_6: false,
  });
  const [amounts, setAmounts] = useState({
    SUB_1: 0,
    SUB_2: 0,
    SUB_3: 0,
    SUB_4: 0,
    SUB_5: 0,
    SUB_6: 0,
  });
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const token = sessionStorage.getItem("tokenclassx");
  const rollno = sessionStorage.getItem("rollnumber");
  const rollcode = sessionStorage.getItem("rollcode");
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const token = sessionStorage.getItem("tokenclassx");

    if (!token) {
      navigate("/");
      return;
    }
    /* if (sessionStorage.getItem("ownerstatus") === "NO") {
      navigate("/dashboard");
      return;
    } */
    if (
      sessionStorage.getItem("PaymentStatus") === "S" ||
      sessionStorage.getItem("PaymentStatus") === "P"
    ) {
      navigate("/dashboard");
      return;
    }
    fetch(`${config.API_BASE_URL}/FetchPaymentStatusClass10`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        rollno: rollno,
        rollcode: rollcode,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network error");
        }
        return response.json();
      })
      .then((data) => {
        // console.log(data);
        setStudentData(data.data.StudentDetails || {});
        const examfees = data.data.StudentDetails.FEES;
        // console.log("examfees", examfees);
        setFees(examfees);

        if (data.data?.ScrutinySubjects?.length > 0) {
          const scrutiny = data.data.ScrutinySubjects[0];

          const converted = {};
          const newAmounts = {};

          Object.keys(scrutinySubjects).forEach((key) => {
            const isChecked = scrutiny[key] === "YES";
            converted[key] = isChecked;
            newAmounts[key] = isChecked ? examfees : 0;
          });

          setScrutinySubjects(converted);
          setAmounts(newAmounts);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("API error:", error);
        setLoading(false);
      });
  }, []);

  const handleChange = (key) => {
    setScrutinySubjects((prev) => {
      const updated = { ...prev, [key]: !prev[key] };

      // Set amount to 300 if checked, otherwise 0
      setAmounts((amt) => ({
        ...amt,
        [key]: updated[key] ? fees : 0,
      }));

      return updated;
    });
  };

  const isAtLeastOneSubjectSelected = () => {
    return Object.values(scrutinySubjects).some((selected) => selected);
  };

  const handleSubmit = async () => {
    if (!isAtLeastOneSubjectSelected()) {
      Swal.fire("Please select at least one subject before submitting.");
      return;
    }
    if (!isConfirmed) {
      Swal.fire("Please confirm The Checkbox before submitting.");
      return;
    }
    // Transform scrutinySubjects into suB_1: 'YES' / 'NO' format
    const formattedSubjects = Object.entries(scrutinySubjects).reduce(
      (acc, [key, value]) => {
        acc[key.toLowerCase()] = value ? "YES" : "NO"; // Convert to suB_1 style
        return acc;
      },
      {}
    );

    // Create the final payload
    const payload = {
      rolL_CODE: sessionStorage.getItem("rollcode"), // Replace with actual value
      rolL_NO: sessionStorage.getItem("rollnumber"), // Replace with actual value
      ...formattedSubjects,
      amount:
        (Number(amounts?.SUB_1) || 0) +
        (Number(amounts?.SUB_2) || 0) +
        (Number(amounts?.SUB_3) || 0) +
        (Number(amounts?.SUB_4) || 0) +
        (Number(amounts?.SUB_5) || 0) +
        (Number(amounts?.SUB_6) || 0),
      CONTACT_NO: sessionStorage.getItem("phoneNumber"),
    };
    console.log(payload);
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/InsertStudentScrunityClass10`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      console.log(data);
      if (response.ok) {
        setLoading(false);
        await handleDownloadApplication();
        Swal.fire({
          title: "Submitted successfully!",
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: false, // Prevent closing by clicking outside
          allowEscapeKey: false, // Prevent closing with Esc key
        }).then((result) => {
          if (result.isConfirmed) {
            Navigate("/dashboard");
          }
        });
      } else {
        setLoading(false);
        Swal.fire("Submission failed.", "Please try again.", "error");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      Swal.fire("Something went wrong.", "Please try again.", "error");
    }
  };

  const handleDownloadApplication = async (e) => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem("tokenclassx");
      const rollno = sessionStorage.getItem("rollnumber");
      const rollcode = sessionStorage.getItem("rollcode");

      const response = await fetch(
        `${config.API_BASE_URL}/ScrutinyReceiptReportClass10`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ROLLCODE: rollcode, ROLLNO: rollno }),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch scrutiny data");
      const data = await response.json();
      setLoading(false);
      console.log(data);
      // Generate PDF blob
      const blob = await pdf(<ScrutinyPDF data={data.data} />).toBlob();

      // Only open in a new popup window (no download)
      const blobUrl = URL.createObjectURL(blob);

      window.open(blobUrl, "_blank", "width=900,height=700");
      setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
    } catch (err) {
      setLoading(false);
      console.error("PDF download error:", err);
      alert("Failed to open PDF. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h3 class="content-header-text">
                      {/* <i class="fa fa-user-plus"></i> Student Application Form
                      for NMMSS */}
                    </h3>
                    <ol class="breadcrumb">
                      <li>
                        <a href="index.html">
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active">Student Application Form</li>
                    </ol>
                    <h3></h3>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header bg-brown">
                      <h4 class="mb-0 p-2">Student Information </h4>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div
                          class="col-lg-9 col-m-12"
                          style={{ borderRight: "1px solid #CED4DA" }}
                        >
                          <div class="row">
                            <div class="col-lg-4 col-m-12">
                              <div class="form-group mb-3">
                                <label>Candidate's Full Name</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm "
                                  value={studentData?.CandidateName || ""}
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-12">
                              <div class="form-group mb-3">
                                <label>Father’s Name</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm "
                                  value={studentData?.FatherName || ""}
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-12">
                              <div class="form-group mb-3">
                                <label>Mother’s Name</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm "
                                  value={studentData?.MotherName || ""}
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-lg-8 col-m-12">
                              <div class="form-group mb-3">
                                <label>School Name</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm "
                                  value={studentData?.SchoolName || ""}
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-lg-4 col-m-12">
                              <div class="form-group mb-3">
                                <label>Student ID</label>
                                <input
                                  type="text"
                                  class="form-control form-control-sm "
                                  value={studentData?.StudentID || ""}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-3 col-m-12">
                          <div class="form-group mb-3">
                            <label>Date of Birth</label>
                            <input
                              type="text"
                              class="form-control form-control-sm "
                              value={studentData?.DOB || ""}
                              disabled
                            />
                          </div>
                          <div class="form-group mb-3">
                            <label>Registration No</label>
                            <input
                              type="text"
                              class="form-control form-control-sm "
                              value={studentData?.RegnNo || ""}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4 stretch-card">
                  <div class="card">
                    <div class="card-header bg-brown">
                      <h4 class="mb-0 p-2">Marks Information </h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table table-striped table-condensed table-bordered">
                            <thead>
                              <tr>
                                <th>SUBJECT</th>
                                <th className="text-center">FULL MARKS</th>
                                <th className="text-center">OBTAINED MARKS</th>
                                <th style={{ textAlign: "center" }}>
                                  SCRUTINY
                                </th>
                                <th style={{ width: "150px" }}>AMOUNT</th>
                              </tr>
                            </thead>
                            <tbody>
                              {studentData?.Sub1Code ? (
                                <tr>
                                  <td>{studentData.Sub1Name} ( {studentData?.Sub1Code || ""} )</td>
                                  <td className="text-center">
                                    {studentData?.Sub1ThFM
                                      ? String(studentData.Sub1ThFM).padStart(3, "0")
                                      : ""}
                                  </td>
                                  <td className="text-center">
                                    {studentData?.Sub1ThOM || ""}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      style={{ transform: "scale(1.3)" }}
                                      type="checkbox"
                                      checked={scrutinySubjects.SUB_1}
                                      disabled={isPreviewMode}
                                      onChange={
                                        isPreviewMode
                                          ? undefined
                                          : () => handleChange("SUB_1")
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-xs"
                                      disabled
                                      value={amounts.SUB_1}
                                      style={{ textAlign: "right" }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                              {studentData?.Sub2Code ? (
                                <tr>
                                  <td>{studentData.Sub2Name} ( {studentData?.Sub2Code || ""} )</td>
                                  <td className="text-center">
                                    {studentData?.Sub2ThFM
                                      ? String(studentData.Sub2ThFM).padStart(3, "0")
                                      : ""}       
                                  </td>
                                  <td className="text-center">
                                    {studentData?.Sub2ThOM || ""}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      style={{ transform: "scale(1.3)" }}
                                      type="checkbox"
                                      checked={scrutinySubjects.SUB_2}
                                      disabled={isPreviewMode}
                                      onChange={
                                        isPreviewMode
                                          ? undefined
                                          : () => handleChange("SUB_2")
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-xs"
                                      disabled
                                      value={amounts.SUB_2}
                                      style={{ textAlign: "right" }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                              {studentData?.Sub3Code ? (
                                <tr>
                                  <td>{studentData.Sub3Name} ( {studentData?.Sub3Code || ""} )</td>
                                  <td className="text-center">
                                    {studentData?.Sub3ThFM
                                      ? String(studentData.Sub3ThFM).padStart(3, "0")
                                      : ""}       
                                  </td>
                                  <td className="text-center">
                                    {studentData?.Sub3ThOM || ""}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      style={{ transform: "scale(1.3)" }}
                                      type="checkbox"
                                      checked={scrutinySubjects.SUB_3}
                                      disabled={isPreviewMode}
                                      onChange={
                                        isPreviewMode
                                          ? undefined
                                          : () => handleChange("SUB_3")
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-xs"
                                      disabled
                                      value={amounts.SUB_3}
                                      style={{ textAlign: "right" }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                              {studentData?.Sub4Code ? (
                                <tr>
                                  <td>{studentData.Sub4Name} ( {studentData?.Sub4Code || ""} )</td>
                                  <td className="text-center">
                                    {studentData?.Sub4ThFM
                                      ? String(studentData.Sub4ThFM).padStart(3, "0")
                                      : ""}       
                                  </td>
                                  <td className="text-center">
                                    {studentData?.Sub4ThOM || ""}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      style={{ transform: "scale(1.3)" }}
                                      type="checkbox"
                                      checked={scrutinySubjects.SUB_4}
                                      disabled={isPreviewMode}
                                      onChange={
                                        isPreviewMode
                                          ? undefined
                                          : () => handleChange("SUB_4")
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-xs"
                                      disabled
                                      value={amounts.SUB_4}
                                      style={{ textAlign: "right" }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                              {studentData?.Sub5Code ? (
                                <tr>
                                  <td>{studentData?.Sub5Name || ""} ( {studentData?.Sub5Code || ""} )</td>
                                  <td className="text-center">
                                    {studentData?.Sub5ThFM
                                      ? String(studentData.Sub5ThFM).padStart(3, "0")
                                      : ""}       
                                  </td>
                                  <td className="text-center">
                                    {studentData?.Sub5ThOM || ""}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      style={{ transform: "scale(1.3)" }}
                                      type="checkbox"
                                      checked={scrutinySubjects.SUB_5}
                                      disabled={isPreviewMode}
                                      onChange={
                                        isPreviewMode
                                          ? undefined
                                          : () => handleChange("SUB_5")
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-xs"
                                      disabled
                                      value={amounts.SUB_5}
                                      style={{ textAlign: "right" }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                              {studentData?.Sub6Code ? (
                                <tr>
                                  <td>{studentData?.Sub6Name || ""} ( {studentData?.Sub6Code || ""} )</td>
                                  <td className="text-center">
                                    {studentData?.Sub6ThFM
                                      ? String(studentData.Sub6ThFM).padStart(3, "0")
                                      : ""}
                                  </td>
                                  <td className="text-center">
                                    {studentData?.Sub6ThOM || ""}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    <input
                                      style={{ transform: "scale(1.3)" }}
                                      type="checkbox"
                                      checked={scrutinySubjects.SUB_6}
                                      disabled={isPreviewMode}
                                      onChange={
                                        isPreviewMode
                                          ? undefined
                                          : () => handleChange("SUB_6")
                                      }
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control form-control-xs"
                                      disabled
                                      value={amounts.SUB_6}
                                      style={{ textAlign: "right" }}
                                    />
                                  </td>
                                </tr>
                              ) : (
                                ""
                              )}
                            </tbody>
                            <tfoot>
                              <tr>
                                {/* <td colSpan="3"></td> */}
                                {/* <td
                                  style={{ fontWeight: "600" }}
                                  className="text-center"
                                >
                                  {(Number(studentData?.Sub1ThFM) || 0) +
                                    (Number(studentData?.Sub2ThFM) || 0) +
                                    (Number(studentData?.Sub3ThFM) || 0) +
                                    (Number(studentData?.Sub4ThFM) || 0) +
                                    (Number(studentData?.Sub5ThFM) || 0) +
                                    (Number(studentData?.Sub6ThFM) || 0)}
                                </td>
                                <td
                                  style={{ fontWeight: "600" }}
                                  className="text-center"
                                >
                                  {(Number(studentData?.Sub1ThOM) || 0) +
                                    (Number(studentData?.Sub2ThOM) || 0) +
                                    (Number(studentData?.Sub3ThOM) || 0) +
                                    (Number(studentData?.Sub4ThOM) || 0) +
                                    (Number(studentData?.Sub5ThOM) || 0) +
                                    (Number(studentData?.Sub6ThOM) || 0)}
                                </td> */}
                                <td
                                  colSpan="4"
                                  style={{
                                    textAlign: "right",
                                    fontWeight: "600",
                                  }}
                                >
                                  Total Amount :
                                </td>
                                <td style={{ fontWeight: "600" }}>
                                  <input
                                    type="text"
                                    className="form-control form-control-xs"
                                    value={(
                                      (Number(amounts?.SUB_1) || 0) +
                                      (Number(amounts?.SUB_2) || 0) +
                                      (Number(amounts?.SUB_3) || 0) +
                                      (Number(amounts?.SUB_4) || 0) +
                                      (Number(amounts?.SUB_5) || 0) +
                                      (Number(amounts?.SUB_6) || 0)
                                    ).toFixed(2)}
                                    style={{ textAlign: "right", color: "red" }}
                                    disabled
                                  />
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-7">
                          {isPreviewMode && (
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "1rem",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isConfirmed}
                                onChange={(e) =>
                                  setIsConfirmed(e.target.checked)
                                }
                                style={{
                                  transform: "scale(1.3)",
                                  marginRight: "0.5rem",
                                }}
                              />
                              <span className="text-danger fw-bold">
                                I confirm my details are correct and agree to
                                submit the form.
                              </span>
                            </label>
                          )}
                        </div>

                        <div
                          className="col-md-5"
                          style={{ textAlign: "right" }}
                        >
                          {!isPreviewMode ? (
                            <button
                              className="btn bg-warning me-2"
                              onClick={() => {
                                if (isAtLeastOneSubjectSelected()) {
                                  setIsPreviewMode(true);
                                } else {
                                  Swal.fire(
                                    "Please select at least one subject before previewing."
                                  );
                                }
                              }}
                            >
                              <i className="fa fa-eye"></i> Preview
                            </button>
                          ) : (
                            <>
                              <button
                                className="btn btn-info me-2"
                                onClick={() => setIsPreviewMode(false)}
                              >
                                <i className="fa fa-edit"></i> Edit
                              </button>
                              <button
                                style={{ color: "white" }}
                                className="btn bg-success me-2"
                                onClick={handleSubmit}
                              >
                                <i className="fa fa-save"></i> Submit
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentInformation;
